import advancedFilters from "./advancedFilters.json";
import agentBots from "./agentBots.json";
import agentMgmt from "./agentMgmt.json";
import attributesMgmt from "./attributesMgmt.json";
import automation from "./automation.json";
import bugReport from "./bugReport.json";
import bulkActions from "./bulkActions.json";
import bulkBroadcast from "./bulkBroadcast.json";
import campaign from "./campaign.json";
import cannedMgmt from "./cannedMgmt.json";
import chatlist from "./chatlist.json";
import components from "./components.json";
import crm from "./crm.json";
import contact from "./contact.json";
import contactFilters from "./contactFilters.json";
import conversation from "./conversation.json";
import csatMgmt from "./csatMgmt.json";
import customRole from "./customRole.json";
import datePicker from "./datePicker.json";
import emoji from "./emoji.json";
import general from "./general.json";
import generalSettings from "./generalSettings.json";
import helpCenter from "./helpCenter.json";
import inbox from "./inbox.json";
import inboxMgmt from "./inboxMgmt.json";
import integrationApps from "./integrationApps.json";
import integrations from "./integrations.json";
import labelsMgmt from "./labelsMgmt.json";
import login from "./login.json";
import macros from "./macros.json";
import report from "./report.json";
import resetPassword from "./resetPassword.json";
import search from "./search.json";
import setNewPassword from "./setNewPassword.json";
import settings from "./settings.json";
import signup from "./signup.json";
import sla from "./sla.json";
import teamsSettings from "./teamsSettings.json";
import tasks from "./tasks.json";
import whatsappTemplates from "./whatsappTemplates.json";
import announcements from "./announcements.json";

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...automation,
  ...bugReport,
  ...bulkActions,
  ...bulkBroadcast,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...components,
  ...crm,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...tasks,
  ...teamsSettings,
  ...whatsappTemplates,
  ...announcements,
};
